/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import useSwr from 'swr';
import type {
  Arguments,
  Key,
  SWRConfiguration
} from 'swr';

import useSWRMutation from 'swr/mutation';
import type {
  SWRMutationConfiguration
} from 'swr/mutation';

import { fetchWithAuth } from './fetchWithAuth';
import type { ErrorType, BodyType } from './fetchWithAuth';
export type BlobLinksMain = string | null;

export type BlobLinksPreview = string | null;

export type BlobLinksThumbnail = string | null;

export interface BlobLinks {
  main?: BlobLinksMain;
  preview?: BlobLinksPreview;
  thumbnail?: BlobLinksThumbnail;
}

export interface BodyCreateUserApiUsersNewPost {
  username: string;
  password: string;
}

export type BodyGenerateTokenApiAuthTokenPostGrantType = string | null;

export type BodyGenerateTokenApiAuthTokenPostClientId = string | null;

export type BodyGenerateTokenApiAuthTokenPostClientSecret = string | null;

export interface BodyGenerateTokenApiAuthTokenPost {
  grant_type?: BodyGenerateTokenApiAuthTokenPostGrantType;
  username: string;
  password: string;
  scope?: string;
  client_id?: BodyGenerateTokenApiAuthTokenPostClientId;
  client_secret?: BodyGenerateTokenApiAuthTokenPostClientSecret;
}

export type BodyPutFileApiFilePathPutMeta = { [key: string]: unknown };

export interface BodyPutFileApiFilePathPut {
  blobs: FileBlobs;
  meta: BodyPutFileApiFilePathPutMeta;
}

export interface FeatureFlags {
  enable_shares: boolean;
  enable_password_login: boolean;
}

/**
 * MongoDB document ObjectID
 */
export type _FileId = string | null;

export type FileEvent = string | null;

export interface File {
  /** MongoDB document ObjectID */
  _id?: _FileId;
  name: string;
  blobs: FileBlobs;
  event?: FileEvent;
  tags?: string[];
  meta: Metadata;
}

export type FileBlobsPreview = string | null;

export type FileBlobsThumbnail = string | null;

export interface FileBlobs {
  main: string;
  preview?: FileBlobsPreview;
  thumbnail?: FileBlobsThumbnail;
}

export type FileSlimEvent = string | null;

export interface FileSlim {
  name: string;
  blobs: FileBlobs;
  event?: FileSlimEvent;
  tags?: string[];
  meta: MetadataSlim;
}

export type FilesByYearPrevYear = number | null;

export type FilesByYearNextYear = number | null;

export interface FilesByYear {
  files: FileSlim[];
  prevYear: FilesByYearPrevYear;
  nextYear: FilesByYearNextYear;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export type MetadataExtracted = { [key: string]: number | number | string | boolean | string | null };

export interface Metadata {
  size: number;
  width: number;
  height: number;
  previewSize: number;
  previewWidth: number;
  previewHeight: number;
  thumbnailSize: number;
  thumbnailWidth: number;
  thumbnailHeight: number;
  originalName: string;
  date: string;
  previewIsVideo?: boolean;
  extracted?: MetadataExtracted;
}

export interface MetadataSlim {
  size: number;
  width: number;
  height: number;
  previewSize: number;
  previewWidth: number;
  previewHeight: number;
  thumbnailSize: number;
  thumbnailWidth: number;
  thumbnailHeight: number;
  originalName: string;
  date: string;
  previewIsVideo?: boolean;
}

export type ModifyInputEvent = string | null;

export type ModifyInputDate = string | null;

export interface ModifyInput {
  name: string;
  event?: ModifyInputEvent;
  tags?: string[];
  date?: ModifyInputDate;
}

export interface SessionInfo {
  id: string;
  last_used: string;
  description: string;
}

/**
 * MongoDB document ObjectID
 */
export type _ShareId = string | null;

export interface Share {
  name: string;
  description: string;
  tags?: string[];
  events?: string[];
  exclude_tags?: string[];
  /** MongoDB document ObjectID */
  _id?: _ShareId;
}

export interface ShareData {
  name: string;
  description: string;
  tags?: string[];
  events?: string[];
  exclude_tags?: string[];
}

export type ShareDataPartialName = string | null;

export type ShareDataPartialDescription = string | null;

export type ShareDataPartialTags = string[] | null;

export type ShareDataPartialEvents = string[] | null;

export type ShareDataPartialExcludeTags = string[] | null;

export interface ShareDataPartial {
  name?: ShareDataPartialName;
  description?: ShareDataPartialDescription;
  tags?: ShareDataPartialTags;
  events?: ShareDataPartialEvents;
  exclude_tags?: ShareDataPartialExcludeTags;
}

export interface ShareInfo {
  share: Share;
  files: FileSlim[];
}

export type ValidationErrorLocItem = string | number;

export interface ValidationError {
  loc: ValidationErrorLocItem[];
  msg: string;
  type: string;
}

export type GetFiles200 = { [key: string]: FileSlim };

export type PutFileParams = {
  event?: string | null;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get Sessions
 */
export const getSessions = (

  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<SessionInfo[]>(
    {
      url: `/api/auth/sessions/sessions/`, method: 'GET'
    },
    options);
}



export const getGetSessionsKey = () => [`/api/auth/sessions/sessions/`] as const;

export type GetSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof getSessions>>>
export type GetSessionsQueryError = ErrorType<unknown>

/**
 * @summary Get Sessions
 */
export const useGetSessions = <TError = ErrorType<unknown>>(
  options?: { swr?: SWRConfiguration<Awaited<ReturnType<typeof getSessions>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof fetchWithAuth> }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetSessionsKey() : null);
  const swrFn = () => getSessions(requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create Session
 */
export const createSession = (
  createSessionBody: BodyType<string>,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<string>(
    {
      url: `/api/auth/sessions/sessions/create`, method: 'POST',
      headers: { 'Content-Type': 'application/json', },
      data: createSessionBody
    },
    options);
}



export const getCreateSessionMutationFetcher = (options?: SecondParameter<typeof fetchWithAuth>) => {
  return (_: Key, { arg }: { arg: string }): Promise<string> => {
    return createSession(arg, options);
  }
}
export const getCreateSessionMutationKey = () => [`/api/auth/sessions/sessions/create`] as const;

export type CreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSession>>>
export type CreateSessionMutationError = ErrorType<HTTPValidationError>

/**
 * @summary Create Session
 */
export const useCreateSession = <TError = ErrorType<HTTPValidationError>>(
  options?: { swr?: SWRMutationConfiguration<Awaited<ReturnType<typeof createSession>>, TError, Key, string, Awaited<ReturnType<typeof createSession>>> & { swrKey?: string }, request?: SecondParameter<typeof fetchWithAuth> }
) => {

  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateSessionMutationKey();
  const swrFn = getCreateSessionMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Get Session Access Token
 */
export const getSessionAccessToken = (
  getSessionAccessTokenBody: BodyType<string>,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<string>(
    {
      url: `/api/auth/sessions/sessions/get_token`, method: 'POST',
      headers: { 'Content-Type': 'application/json', },
      data: getSessionAccessTokenBody
    },
    options);
}



export const getGetSessionAccessTokenMutationFetcher = (options?: SecondParameter<typeof fetchWithAuth>) => {
  return (_: Key, { arg }: { arg: string }): Promise<string> => {
    return getSessionAccessToken(arg, options);
  }
}
export const getGetSessionAccessTokenMutationKey = () => [`/api/auth/sessions/sessions/get_token`] as const;

export type GetSessionAccessTokenMutationResult = NonNullable<Awaited<ReturnType<typeof getSessionAccessToken>>>
export type GetSessionAccessTokenMutationError = ErrorType<HTTPValidationError>

/**
 * @summary Get Session Access Token
 */
export const useGetSessionAccessToken = <TError = ErrorType<HTTPValidationError>>(
  options?: { swr?: SWRMutationConfiguration<Awaited<ReturnType<typeof getSessionAccessToken>>, TError, Key, string, Awaited<ReturnType<typeof getSessionAccessToken>>> & { swrKey?: string }, request?: SecondParameter<typeof fetchWithAuth> }
) => {

  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getGetSessionAccessTokenMutationKey();
  const swrFn = getGetSessionAccessTokenMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Revoke Session
 */
export const revokeSession = (
  id: string,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<unknown>(
    {
      url: `/api/auth/sessions/sessions/${id}`, method: 'DELETE'
    },
    options);
}



export const getRevokeSessionMutationFetcher = (id: string, options?: SecondParameter<typeof fetchWithAuth>) => {
  return (_: Key, __: { arg: Arguments }): Promise<unknown> => {
    return revokeSession(id, options);
  }
}
export const getRevokeSessionMutationKey = (id: string,) => [`/api/auth/sessions/sessions/${id}`] as const;

export type RevokeSessionMutationResult = NonNullable<Awaited<ReturnType<typeof revokeSession>>>
export type RevokeSessionMutationError = ErrorType<HTTPValidationError>

/**
 * @summary Revoke Session
 */
export const useRevokeSession = <TError = ErrorType<HTTPValidationError>>(
  id: string, options?: { swr?: SWRMutationConfiguration<Awaited<ReturnType<typeof revokeSession>>, TError, Key, Arguments, Awaited<ReturnType<typeof revokeSession>>> & { swrKey?: string }, request?: SecondParameter<typeof fetchWithAuth> }
) => {

  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getRevokeSessionMutationKey(id);
  const swrFn = getRevokeSessionMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Get Current User
 */
export const getCurrentUser = (

  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<string>(
    {
      url: `/api/users/me/`, method: 'GET'
    },
    options);
}



export const getGetCurrentUserKey = () => [`/api/users/me/`] as const;

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type GetCurrentUserQueryError = ErrorType<unknown>

/**
 * @summary Get Current User
 */
export const useGetCurrentUser = <TError = ErrorType<unknown>>(
  options?: { swr?: SWRConfiguration<Awaited<ReturnType<typeof getCurrentUser>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof fetchWithAuth> }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetCurrentUserKey() : null);
  const swrFn = () => getCurrentUser(requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create User
 */
export const createUser = (
  bodyCreateUserApiUsersNewPost: BodyType<BodyCreateUserApiUsersNewPost>,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<unknown>(
    {
      url: `/api/users/new/`, method: 'POST',
      headers: { 'Content-Type': 'application/json', },
      data: bodyCreateUserApiUsersNewPost
    },
    options);
}



export const getCreateUserMutationFetcher = (options?: SecondParameter<typeof fetchWithAuth>) => {
  return (_: Key, { arg }: { arg: BodyCreateUserApiUsersNewPost }): Promise<unknown> => {
    return createUser(arg, options);
  }
}
export const getCreateUserMutationKey = () => [`/api/users/new/`] as const;

export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
export type CreateUserMutationError = ErrorType<HTTPValidationError>

/**
 * @summary Create User
 */
export const useCreateUser = <TError = ErrorType<HTTPValidationError>>(
  options?: { swr?: SWRMutationConfiguration<Awaited<ReturnType<typeof createUser>>, TError, Key, BodyCreateUserApiUsersNewPost, Awaited<ReturnType<typeof createUser>>> & { swrKey?: string }, request?: SecondParameter<typeof fetchWithAuth> }
) => {

  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateUserMutationKey();
  const swrFn = getCreateUserMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary List Users
 */
export const listUsers = (

  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<string[]>(
    {
      url: `/api/users/`, method: 'GET'
    },
    options);
}



export const getListUsersKey = () => [`/api/users/`] as const;

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<unknown>

/**
 * @summary List Users
 */
export const useListUsers = <TError = ErrorType<unknown>>(
  options?: { swr?: SWRConfiguration<Awaited<ReturnType<typeof listUsers>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof fetchWithAuth> }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListUsersKey() : null);
  const swrFn = () => listUsers(requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete User
 */
export const deleteUser = (
  name: string,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<unknown>(
    {
      url: `/api/users/${name}`, method: 'DELETE'
    },
    options);
}



export const getDeleteUserMutationFetcher = (name: string, options?: SecondParameter<typeof fetchWithAuth>) => {
  return (_: Key, __: { arg: Arguments }): Promise<unknown> => {
    return deleteUser(name, options);
  }
}
export const getDeleteUserMutationKey = (name: string,) => [`/api/users/${name}`] as const;

export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>
export type DeleteUserMutationError = ErrorType<HTTPValidationError>

/**
 * @summary Delete User
 */
export const useDeleteUser = <TError = ErrorType<HTTPValidationError>>(
  name: string, options?: { swr?: SWRMutationConfiguration<Awaited<ReturnType<typeof deleteUser>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteUser>>> & { swrKey?: string }, request?: SecondParameter<typeof fetchWithAuth> }
) => {

  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteUserMutationKey(name);
  const swrFn = getDeleteUserMutationFetcher(name, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Get Files
 */
export const getFiles = (

  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<GetFiles200>(
    {
      url: `/api/file/`, method: 'GET'
    },
    options);
}



export const getGetFilesKey = () => [`/api/file/`] as const;

export type GetFilesQueryResult = NonNullable<Awaited<ReturnType<typeof getFiles>>>
export type GetFilesQueryError = ErrorType<unknown>

/**
 * @summary Get Files
 */
export const useGetFiles = <TError = ErrorType<unknown>>(
  options?: { swr?: SWRConfiguration<Awaited<ReturnType<typeof getFiles>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof fetchWithAuth> }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetFilesKey() : null);
  const swrFn = () => getFiles(requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Get Files By Year
 */
export const getFilesByYear = (
  year: number,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<FilesByYear>(
    {
      url: `/api/file/by-year/${year}/`, method: 'GET'
    },
    options);
}



export const getGetFilesByYearKey = (year: number,) => [`/api/file/by-year/${year}/`] as const;

export type GetFilesByYearQueryResult = NonNullable<Awaited<ReturnType<typeof getFilesByYear>>>
export type GetFilesByYearQueryError = ErrorType<HTTPValidationError>

/**
 * @summary Get Files By Year
 */
export const useGetFilesByYear = <TError = ErrorType<HTTPValidationError>>(
  year: number, options?: { swr?: SWRConfiguration<Awaited<ReturnType<typeof getFilesByYear>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof fetchWithAuth> }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(year)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetFilesByYearKey(year) : null);
  const swrFn = () => getFilesByYear(year, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Bulk Modify
 */
export const bulkModify = (
  modifyInput: ModifyInput[],
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<ModifyInput[]>(
    {
      url: `/api/file/modify`, method: 'POST',
      headers: { 'Content-Type': 'application/json', },
      data: modifyInput
    },
    options);
}



export const getBulkModifyMutationFetcher = (options?: SecondParameter<typeof fetchWithAuth>) => {
  return (_: Key, { arg }: { arg: ModifyInput[] }): Promise<ModifyInput[]> => {
    return bulkModify(arg, options);
  }
}
export const getBulkModifyMutationKey = () => [`/api/file/modify`] as const;

export type BulkModifyMutationResult = NonNullable<Awaited<ReturnType<typeof bulkModify>>>
export type BulkModifyMutationError = ErrorType<HTTPValidationError>

/**
 * @summary Bulk Modify
 */
export const useBulkModify = <TError = ErrorType<HTTPValidationError>>(
  options?: { swr?: SWRMutationConfiguration<Awaited<ReturnType<typeof bulkModify>>, TError, Key, ModifyInput[], Awaited<ReturnType<typeof bulkModify>>> & { swrKey?: string }, request?: SecondParameter<typeof fetchWithAuth> }
) => {

  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getBulkModifyMutationKey();
  const swrFn = getBulkModifyMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Bulk Delete
 */
export const bulkDelete = (
  bulkDeleteBody: string[],
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<unknown>(
    {
      url: `/api/file/delete`, method: 'POST',
      headers: { 'Content-Type': 'application/json', },
      data: bulkDeleteBody
    },
    options);
}



export const getBulkDeleteMutationFetcher = (options?: SecondParameter<typeof fetchWithAuth>) => {
  return (_: Key, { arg }: { arg: string[] }): Promise<unknown> => {
    return bulkDelete(arg, options);
  }
}
export const getBulkDeleteMutationKey = () => [`/api/file/delete`] as const;

export type BulkDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDelete>>>
export type BulkDeleteMutationError = ErrorType<HTTPValidationError>

/**
 * @summary Bulk Delete
 */
export const useBulkDelete = <TError = ErrorType<HTTPValidationError>>(
  options?: { swr?: SWRMutationConfiguration<Awaited<ReturnType<typeof bulkDelete>>, TError, Key, string[], Awaited<ReturnType<typeof bulkDelete>>> & { swrKey?: string }, request?: SecondParameter<typeof fetchWithAuth> }
) => {

  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getBulkDeleteMutationKey();
  const swrFn = getBulkDeleteMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Put File
 */
export const putFile = (
  path: string,
  bodyPutFileApiFilePathPut: BodyType<BodyPutFileApiFilePathPut>,
  params?: PutFileParams,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<BlobLinks>(
    {
      url: `/api/file/${path}`, method: 'PUT',
      headers: { 'Content-Type': 'application/json', },
      data: bodyPutFileApiFilePathPut,
      params
    },
    options);
}



export const getPutFileMutationFetcher = (path: string,
  params?: PutFileParams, options?: SecondParameter<typeof fetchWithAuth>) => {
  return (_: Key, { arg }: { arg: BodyPutFileApiFilePathPut }): Promise<BlobLinks> => {
    return putFile(path, arg, params, options);
  }
}
export const getPutFileMutationKey = (path: string,
  params?: PutFileParams,) => [`/api/file/${path}`, ...(params ? [params] : [])] as const;

export type PutFileMutationResult = NonNullable<Awaited<ReturnType<typeof putFile>>>
export type PutFileMutationError = ErrorType<HTTPValidationError>

/**
 * @summary Put File
 */
export const usePutFile = <TError = ErrorType<HTTPValidationError>>(
  path: string,
  params?: PutFileParams, options?: { swr?: SWRMutationConfiguration<Awaited<ReturnType<typeof putFile>>, TError, Key, BodyPutFileApiFilePathPut, Awaited<ReturnType<typeof putFile>>> & { swrKey?: string }, request?: SecondParameter<typeof fetchWithAuth> }
) => {

  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPutFileMutationKey(path, params);
  const swrFn = getPutFileMutationFetcher(path, params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Get Details
 */
export const getDetails = (
  path: string,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<File>(
    {
      url: `/api/file/${path}/details`, method: 'GET'
    },
    options);
}



export const getGetDetailsKey = (path: string,) => [`/api/file/${path}/details`] as const;

export type GetDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getDetails>>>
export type GetDetailsQueryError = ErrorType<HTTPValidationError>

/**
 * @summary Get Details
 */
export const useGetDetails = <TError = ErrorType<HTTPValidationError>>(
  path: string, options?: { swr?: SWRConfiguration<Awaited<ReturnType<typeof getDetails>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof fetchWithAuth> }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(path)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetDetailsKey(path) : null);
  const swrFn = () => getDetails(path, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary List Shares
 */
export const listShares = (

  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<Share[]>(
    {
      url: `/api/share/`, method: 'GET'
    },
    options);
}



export const getListSharesKey = () => [`/api/share/`] as const;

export type ListSharesQueryResult = NonNullable<Awaited<ReturnType<typeof listShares>>>
export type ListSharesQueryError = ErrorType<unknown>

/**
 * @summary List Shares
 */
export const useListShares = <TError = ErrorType<unknown>>(
  options?: { swr?: SWRConfiguration<Awaited<ReturnType<typeof listShares>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof fetchWithAuth> }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getListSharesKey() : null);
  const swrFn = () => listShares(requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Create Share
 */
export const createShare = (
  shareData: BodyType<ShareData>,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<Share>(
    {
      url: `/api/share/`, method: 'POST',
      headers: { 'Content-Type': 'application/json', },
      data: shareData
    },
    options);
}



export const getCreateShareMutationFetcher = (options?: SecondParameter<typeof fetchWithAuth>) => {
  return (_: Key, { arg }: { arg: ShareData }): Promise<Share> => {
    return createShare(arg, options);
  }
}
export const getCreateShareMutationKey = () => [`/api/share/`] as const;

export type CreateShareMutationResult = NonNullable<Awaited<ReturnType<typeof createShare>>>
export type CreateShareMutationError = ErrorType<HTTPValidationError>

/**
 * @summary Create Share
 */
export const useCreateShare = <TError = ErrorType<HTTPValidationError>>(
  options?: { swr?: SWRMutationConfiguration<Awaited<ReturnType<typeof createShare>>, TError, Key, ShareData, Awaited<ReturnType<typeof createShare>>> & { swrKey?: string }, request?: SecondParameter<typeof fetchWithAuth> }
) => {

  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateShareMutationKey();
  const swrFn = getCreateShareMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Get Share
 */
export const getShare = (
  id: string,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<ShareInfo>(
    {
      url: `/api/share/${id}`, method: 'GET'
    },
    options);
}



export const getGetShareKey = (id: string,) => [`/api/share/${id}`] as const;

export type GetShareQueryResult = NonNullable<Awaited<ReturnType<typeof getShare>>>
export type GetShareQueryError = ErrorType<HTTPValidationError>

/**
 * @summary Get Share
 */
export const useGetShare = <TError = ErrorType<HTTPValidationError>>(
  id: string, options?: { swr?: SWRConfiguration<Awaited<ReturnType<typeof getShare>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof fetchWithAuth> }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(id)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetShareKey(id) : null);
  const swrFn = () => getShare(id, requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Update Share
 */
export const updateShare = (
  id: string,
  shareDataPartial: BodyType<ShareDataPartial>,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<Share>(
    {
      url: `/api/share/${id}`, method: 'PATCH',
      headers: { 'Content-Type': 'application/json', },
      data: shareDataPartial
    },
    options);
}



export const getUpdateShareMutationFetcher = (id: string, options?: SecondParameter<typeof fetchWithAuth>) => {
  return (_: Key, { arg }: { arg: ShareDataPartial }): Promise<Share> => {
    return updateShare(id, arg, options);
  }
}
export const getUpdateShareMutationKey = (id: string,) => [`/api/share/${id}`] as const;

export type UpdateShareMutationResult = NonNullable<Awaited<ReturnType<typeof updateShare>>>
export type UpdateShareMutationError = ErrorType<HTTPValidationError>

/**
 * @summary Update Share
 */
export const useUpdateShare = <TError = ErrorType<HTTPValidationError>>(
  id: string, options?: { swr?: SWRMutationConfiguration<Awaited<ReturnType<typeof updateShare>>, TError, Key, ShareDataPartial, Awaited<ReturnType<typeof updateShare>>> & { swrKey?: string }, request?: SecondParameter<typeof fetchWithAuth> }
) => {

  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateShareMutationKey(id);
  const swrFn = getUpdateShareMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Delete Share
 */
export const deleteShare = (
  id: string,
  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<unknown>(
    {
      url: `/api/share/${id}`, method: 'DELETE'
    },
    options);
}



export const getDeleteShareMutationFetcher = (id: string, options?: SecondParameter<typeof fetchWithAuth>) => {
  return (_: Key, __: { arg: Arguments }): Promise<unknown> => {
    return deleteShare(id, options);
  }
}
export const getDeleteShareMutationKey = (id: string,) => [`/api/share/${id}`] as const;

export type DeleteShareMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShare>>>
export type DeleteShareMutationError = ErrorType<HTTPValidationError>

/**
 * @summary Delete Share
 */
export const useDeleteShare = <TError = ErrorType<HTTPValidationError>>(
  id: string, options?: { swr?: SWRMutationConfiguration<Awaited<ReturnType<typeof deleteShare>>, TError, Key, Arguments, Awaited<ReturnType<typeof deleteShare>>> & { swrKey?: string }, request?: SecondParameter<typeof fetchWithAuth> }
) => {

  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getDeleteShareMutationKey(id);
  const swrFn = getDeleteShareMutationFetcher(id, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

/**
 * @summary Get Feature Flags
 */
export const getFeatureFlags = (

  options?: SecondParameter<typeof fetchWithAuth>) => {
  return fetchWithAuth<FeatureFlags>(
    {
      url: `/api/features/`, method: 'GET'
    },
    options);
}



export const getGetFeatureFlagsKey = () => [`/api/features/`] as const;

export type GetFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof getFeatureFlags>>>
export type GetFeatureFlagsQueryError = ErrorType<unknown>

/**
 * @summary Get Feature Flags
 */
export const useGetFeatureFlags = <TError = ErrorType<unknown>>(
  options?: { swr?: SWRConfiguration<Awaited<ReturnType<typeof getFeatureFlags>>, TError> & { swrKey?: Key, enabled?: boolean }, request?: SecondParameter<typeof fetchWithAuth> }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {}

  const isEnabled = swrOptions?.enabled !== false
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetFeatureFlagsKey() : null);
  const swrFn = () => getFeatureFlags(requestOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}
